module.exports = "<div class=\"log\" ng-class=\"{ 'playing': vm.sequencer.playing }\">\n  <div ng-repeat=\"row in vm.data track by $index\" class=\"row\">\n    <div ng-repeat=\"item in row track by $index\" class=\"col-xs-1\">{{item}}</div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/web/viz/info-log.html
// module id = 213
// module chunks = 0